import { render, staticRenderFns } from "./AllSignatories.vue?vue&type=template&id=26d10f26&scoped=true"
import script from "./AllSignatories.vue?vue&type=script&lang=js"
export * from "./AllSignatories.vue?vue&type=script&lang=js"
import style0 from "./AllSignatories.vue?vue&type=style&index=0&id=26d10f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d10f26",
  null
  
)

export default component.exports